/* RESPONSIBLE TEAM: team-proactive-support */
import SeriesModeConfig from 'embercom/objects/content-editor/series-mode-configuration';
import ComponentConfiguration from 'embercom/objects/content-editor/component-configuration';
import StandardSeriesModeHeaderConfiguration from 'embercom/objects/content-editor/headers/series-mode/standard-header-configuration';
import StandardSeriesViewModeHeaderConfiguration from 'embercom/objects/content-editor/headers/view-mode/standard-series-header-configuration';
import { computed } from '@ember/object';

export default function generateEditorConfig(options) {
  let container = options.container;
  let wait = options.wait;

  return new SeriesModeConfig({
    headerComponentConfig: StandardSeriesModeHeaderConfiguration.extend({
      wait,
      isValid: computed('wait.validations.isValid', function () {
        return wait.validations.isValid;
      }),
      errorMessage: computed('wait.validations.errors.[]', function () {
        return wait.validations.errors?.firstObject?.message;
      }),
    }).create({ container }),
    editorComponentConfigs: [
      ComponentConfiguration.create({
        component: 'content-editor/panels/content/wait/body',
      }),
    ],

    viewModeHeaderConfig: StandardSeriesViewModeHeaderConfiguration.create({ container }),
    viewModeSummaryConfig: ComponentConfiguration.create({
      component: 'content-editor/summaries/content/wait/summary',
    }),
  });
}
